import { TimelineItemCategoryEnum } from "web_myplann/Infrastructure/Api/Api";

export const CATEGORY_PRIORITY: Record<TimelineItemCategoryEnum, number> = {
	[TimelineItemCategoryEnum.Contract]: 1,
	[TimelineItemCategoryEnum.Activity]: 2,
	[TimelineItemCategoryEnum.IdentificationDocument]: 3,
	[TimelineItemCategoryEnum.Reminder]: 4,
	[TimelineItemCategoryEnum.Task]: 5,
	[TimelineItemCategoryEnum.ClientAction]: 6,
	[TimelineItemCategoryEnum.Notification]: 7,
};
